var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQuickActionIconMobTab(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 46,
    height: 45,
    viewBox: "0 0 46 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_7844",
    x: 0,
    y: 0,
    width: 46,
    height: 45,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_30351",
    "data-name": "Group 30351",
    transform: "translate(-472 -1663)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 472, 1663)",
    filter: "url(#Rectangle_7844)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_7844-2",
    "data-name": "Rectangle 7844",
    transform: "translate(9 6)",
    fill: "#fff",
    stroke: "#EB1700",
    strokeWidth: 0.8
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 27,
    rx: 13.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.4,
    y: 0.4,
    width: 27.2,
    height: 26.2,
    rx: 13.1,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_30233",
    "data-name": "Group 30233",
    transform: "translate(-0.886 -1.412)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_15647",
    "data-name": "Ellipse 15647",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(492.886 1673.105)",
    fill: "#EB1700"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_15648",
    "data-name": "Ellipse 15648",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(492.886 1680.912)",
    fill: "#EB1700"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_15649",
    "data-name": "Ellipse 15649",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(492.886 1688.719)",
    fill: "#EB1700"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickActionIconMobTab);
export default __webpack_public_path__ + "static/media/quickActionIcon-mob-tab.2852f47888d30912eee17891c996bcb5.svg";
export { ForwardRef as ReactComponent };